"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const AlliedPartyAgenda_vue_1 = __importDefault(require("@/client/components/turmoil/AlliedPartyAgenda.vue"));
exports.default = (0, vue_1.defineComponent)({
    name: 'PlayerAlliedParty',
    props: {
        player: {
            type: Object,
            required: true,
        },
    },
    components: {
        AlliedPartyAgenda: AlliedPartyAgenda_vue_1.default,
    },
});
